import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import RecommendedInventories from './components/RecommendedInventories';

const recommendedInventories = (props,{ t }) => (
  <Container>
    <RecommendedInventories {...props} />
  </Container>
);

recommendedInventories.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(recommendedInventories);
